;(function () {
  'use strict'

  angular
    .module('contrast.attacks')
    .controller(
      'AttackDiscussionCtrl',
      function AttackDiscussionCtrl(
        $scope,
        $routeParams,
        $q,
        he,
        AttackFactory,
        ErrorService,
        dialogs,
        logger,
        ATTACK_DISCUSSION_EVENTS
      ) {
        'ngInject'

        angular.extend($scope, {
          notes: [],
          note_text: ''
        })

        angular.extend($scope, {
          addNote: addNote,
          editNote: editNote,
          deleteNote: deleteNote,
          compareDates: compareDates
        })

        var attackUuid = $routeParams.attackUuid

        function init() {
          $scope.$emit('attack.tab.active', { active: 'discussion' })
          _loadNotes()
        }

        function _reloadUnreadMessageStatus() {
          $scope.$emit(ATTACK_DISCUSSION_EVENTS.UPDATE)
        }

        function compareDates(note) {
          return note.creation === note.lastModification
        }

        function _loadNotes() {
          AttackFactory.getNotes(attackUuid)
            .then(function (response) {
              $scope.notes = response.data.notes
              angular.forEach($scope.notes, function (note) {
                note.unsafe = he.decode(note.note)
              })
            })
            .catch(ErrorService.processError)

          _reloadUnreadMessageStatus()
        }

        function addNote(note) {
          AttackFactory.addNote(attackUuid, note).then(function (response) {
            logger.logSuccess(response.data.messages[0])
            $scope.$emit(ATTACK_DISCUSSION_EVENTS.ADD)
            $scope.note_text = ''
            _loadNotes()
          })
        }

        function editNote(note, data) {
          if (data.length !== 0 && note.unsafe !== data) {
            return AttackFactory.editNote(attackUuid, note.id, data)
              .then(function (response) {
                logger.logSuccess(response.data.messages[0])
                _loadNotes()
              })
              .catch(ErrorService.processError)
          }
          return $q.when(data)
        }

        function deleteNote(note) {
          dialogs
            .confirm(
              'Please Confirm',
              'Are you sure you want to delete this note?',
              {
                size: 'sm',
                yes: 'Delete'
              }
            )
            .result.then(function () {
              AttackFactory.deleteNote(attackUuid, note.id)
                .then(function (response) {
                  logger.logSuccess(response.data.messages[0])
                  $scope.$emit(ATTACK_DISCUSSION_EVENTS.DELETE)
                  _loadNotes()
                })
                .catch(ErrorService.processError)
            })
        }

        init()
      }
    )
})()
